import React, {Component} from 'react';
import {Form, Control, Errors, Fieldset} from 'react-redux-form';
import {required} from './../field_validations';
import NotificationStatus from './../forms/notification_status';
import EditStatus from './../forms/edit_status';
import _ from 'lodash';
import {toInt} from '../parsers';
import {AUTH_URL} from './../../store/config';

export default class AgreementsEditForm extends Component {
	render() {
		const {agreements, revision, type, modality, state, municipality, municipalities, changeStatus} = this.props;
		let fiscal_entity = !_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) && !_.isEmpty(agreements.data.agency.fiscal_entity) ? agreements.data.agency.fiscal_entity : undefined;
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="revision" onSubmit={(values) => this._handleSubmit(values)}>
						{!_.isEmpty(revision.phase_group) ?
							<h3 className="title is-3" dangerouslySetInnerHTML={{__html: `Revisión - ${revision.phase_group.name}`}} /> : ''}
						<h5 className="title is-5">{modality === 'modalidad-i' ? 'Modalidad I' : (modality === 'modalidad-ii' ? 'Modalidad II' : 'Modalidad III')}</h5>

						<h1 className="title is-6">DATOS DEL PROYECTO</h1>

						<table className="is-fullwidth table project-goal-table no-margin">
							<tbody>
							<tr>
								<td colSpan={3}>
									<span className="help is-dark">Nombre de la instancia</span>
									<strong>{!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) ? agreements.data.agency.name : '---'}</strong>
								</td>
							</tr>
							<tr>
								<td colSpan={3}>
									<span className="help is-dark">Nombre del proyecto</span>
									<strong>{!_.isEmpty(agreements.data) ? agreements.data.name : '---'}</strong>
								</td>
							</tr>
							<tr>
								<td>
									<span className="help is-dark">Año</span>
									<strong>{!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) && !_.isEmpty(agreements.data.agency.version) ? agreements.data.agency.version.year : '---'}</strong>
								</td>
								<td>
									<span className="help is-dark">Entidad</span>
									<strong>{!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) ? agreements.data.agency.agenciable.name : '---'}</strong>
								</td>
								<td>
									<span className="help is-dark">Naturaleza jurídica</span>
									<strong>{!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) ? agreements.data.agency.legal_nature : '---'}</strong>
								</td>
							</tr>
							</tbody>
						</table>

						{type === 'administrativo' ?
							<h1 className="title is-6">INFORMACIÓN</h1>
							: ''}

						{type === 'administrativo' ?
							<table className="is-fullwidth table project-goal-table no-margin">
								<tbody>
								<tr>
									<td colSpan={3} className="goal-cell">
										<strong>ENTIDAD FISCAL DE LA INSTANCIA</strong>
									</td>
								</tr>
								<tr>
									<td colSpan={2}>
										<span className="help is-dark">Nombre</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.name ? fiscal_entity.name : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">RFC</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.rfc ? fiscal_entity.rfc : '---'}</strong>
									</td>
								</tr>
								<tr>
									<td>
										<span className="help is-dark">Municipio</span>
										<strong>{!_.isEmpty(fiscal_entity) && _.find(municipalities.list, {id: fiscal_entity.municipality_id}) !== undefined ? _.find(municipalities.list, {id: fiscal_entity.municipality_id}).name : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Código postal</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.cp ? fiscal_entity.cp : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Colonia</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.colony ? fiscal_entity.colony : '---'}</strong>
									</td>
								</tr>
								<tr>
									<td>
										<span className="help is-dark">Dirección</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.street ? fiscal_entity.street : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Número exterior</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.num_ext ? fiscal_entity.num_ext : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Número Interior</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.num_int ? fiscal_entity.num_int : '---'}</strong>
									</td>
								</tr>
								</tbody>
								<Fieldset model=".agreements.admin.body" component="tbody">
									<tr>
										<td colSpan={3}>
											<div className="field has-addons">
												<div className="control">
													<div className="select">
														<Control
															model="[0].status"
															defaultValue={revision.agreements.admin.body && revision.agreements.admin.body[0] ? revision.agreements.admin.body[0].status : 'success'}
															changeAction={(model, value) => changeStatus(model, value, {
																field: 'entity_fiscal',
																model: 'revision.agreements.admin.body[0].field'
															})}
															component={NotificationStatus}
															errors={{required}}
															validateOn="change"
														/>
													</div>
													<Errors
														model="[0].status"
														show="touched"
														wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
														messages={{required: 'El estatus es obligatorio'}}
													/>
												</div>
												<div className="control is-expanded">
													<Control.text
														model="[0].comment"
														className="input"
														placeholder="Comentario"
													/>
												</div>
												<div className="control">
													<div className="select">
														<Control
															model="[0].allow_edit"
															component={EditStatus}
															defaultValue={revision.agreements.admin.body && !_.isEmpty(revision.agreements.admin.body[0]) && !_.isEmpty(revision.agreements.admin.body[0].allow_edit) ? revision.agreements.admin.body[0].allow_edit : 'false'}
														/>
													</div>
												</div>
											</div>
										</td>
									</tr>
								</Fieldset>
								<tbody>
								<tr>
									<td colSpan={3} className="goal-cell">
										<strong>DATOS BANCARIOS</strong>
									</td>
								</tr>
								<tr>
									<td>
										<span className="help is-dark">Nombre de banco</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.bank_name ? fiscal_entity.bank_name : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Número de cuenta</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.bank_account ? fiscal_entity.bank_account : '---'}</strong>
									</td>
									<td>
										<span
											className="help is-dark">Clave bancaria estandarizada(CLABE 18 digitos)</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.bank_clabe ? fiscal_entity.bank_clabe : '---'}</strong>
									</td>
								</tr>
								<tr>
									<td>
										<span className="help is-dark">Municipio</span>
										<strong>{!_.isEmpty(fiscal_entity) && _.find(municipalities.list, {id: fiscal_entity.municipality_id}) !== undefined ? _.find(municipalities.list, {id: fiscal_entity.municipality_id}).name : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Código postal</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.bank_cp ? fiscal_entity.bank_cp : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Colonia</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.bank_colony ? fiscal_entity.bank_colony : '---'}</strong>
									</td>
								</tr>
								<tr>
									<td>
										<span className="help is-dark">Dirección de la sucursal</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.bank_street ? fiscal_entity.bank_street : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Número exterior</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.bank_num_ext ? fiscal_entity.bank_num_ext : '---'}</strong>
									</td>
									<td>
										<span className="help is-dark">Número Interior</span>
										<strong>{!_.isEmpty(fiscal_entity) && fiscal_entity.bank_num_int ? fiscal_entity.bank_num_int : '---'}</strong>
									</td>
								</tr>
								</tbody>
								<Fieldset model=".agreements.admin.body" component="tbody">
									<tr>
										<td colSpan={3}>
											<div className="field has-addons">
												<div className="control">
													<div className="select">
														<Control
															model="[1].status"
															defaultValue={revision.agreements.admin.body && revision.agreements.admin.body[1] ? revision.agreements.admin.body[1].status : 'success'}
															changeAction={(model, value) => changeStatus(model, value, {
																field: 'bank_data',
																model: 'revision.agreements.admin.body[1].field'
															})}
															component={NotificationStatus} errors={{required}}
															validateOn="change"
														/>
													</div>
													<Errors
														model="[1].status"
														show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
														messages={{required: 'El estatus es obligatorio'}}
													/>
												</div>
												<div className="control is-expanded">
													<Control.text
														model="[1].comment"
														className="input"
														placeholder="Comentario"
													/>
												</div>
												<div className="control">
													<div className="select">
														<Control
															model="[1].allow_edit"
															component={EditStatus}
															defaultValue={revision.agreements.admin.body && !_.isEmpty(revision.agreements.admin.body[1]) && !_.isEmpty(revision.agreements.admin.body[1].allow_edit) ? revision.agreements.admin.body[1].allow_edit : 'false'}
														/>
													</div>
												</div>
											</div>
										</td>
									</tr>
								</Fieldset>
							</table>
							: ''}

						<h1 className="title is-6">DOCUMENTACIÓN</h1>
						<table className="is-fullwidth table project-goal-table no-margin">
							<Fieldset
								model={type === 'juridica' ? '.agreements.legal.body' : '.agreements.admin.body'}
								component="tbody"
							>
								{_.map(_.filter(agreements.documents_items, (o) => {
									return (o.documentable_type === (type === 'juridica' ? 'projects' : 'agencies')) && (o.modality_id === null || o.modality_id === (agreements.data ? agreements.data.modality_id : undefined))
								}), (item, d) => {
									let document = agreements.data && agreements.data.documents && agreements.data.documents[item.slug] && !_.isObject(agreements.data.documents[item.slug]) ? agreements.data.documents[item.slug] : undefined;
									let status = 'success';
									let allow_edit = 'false';
									if (type === 'juridica') {
										status = revision.agreements.legal.body && revision.agreements.legal.body[item.id] ? revision.agreements.legal.body[item.id].status : 'success';
										allow_edit = revision.agreements.legal.body && !_.isEmpty(revision.agreements.legal.body[item.id]) && !_.isEmpty(revision.agreements.legal.body[item.id].allow_edit) ? revision.agreements.legal.body[item.id].allow_edit : 'false'
									} else {
										status = revision.agreements.admin.body && revision.agreements.admin.body[item.id] ? revision.agreements.admin.body[item.id].status : 'success';
										allow_edit = revision.agreements.admin.body && !_.isEmpty(revision.agreements.admin.body[item.id]) && !_.isEmpty(revision.agreements.admin.body[item.id].allow_edit) ? revision.agreements.admin.body[item.id].allow_edit : 'false'
									}
									return (
										<tr key={d}>
											<td colSpan={3}>
												<div className="field">
													<div className="control">
														<a target="_blank" className="button is-info" href={document} disabled={document ? false : true}>
															<span className="icon"><i className="fa fa-link"/></span>
															<span>{item.name}</span>
														</a>
													</div>
												</div>
												<div className="field has-addons">
													<div className="control">
														<div className="select">
															<Control
																model={`[${item.id}].status`}
																id={`[${item.id}].status`}
																defaultValue={status}
																changeAction={(model, value) => changeStatus(model, value, {
																	field: item.slug,
																	model: `revision.agreements.${type === 'juridica' ? 'legal' : 'admin'}.body[${item.id}].field`
																})}
																component={NotificationStatus}
																errors={{required}}
																validateOn="change"
															/>
														</div>
														<Errors
															model={`[${item.id}].status`}
															show="touched"
															wrapper={(props) => <small className="help has-text-danger">{props.children}</small>}
															messages={{required: 'El estatus es obligatorio'}}
														/>
													</div>
													<div className="control is-expanded">
														<Control.text
															model={`[${item.id}].comment`}
															id={`[${item.id}].comment`}
															className="input"
															placeholder="Comentario"
														/>
													</div>
													<div className="control">
														<div className="select">
															<Control
																model={`[${item.id}].allow_edit`}
																id={`[${item.id}].allow_edit`}
																component={EditStatus} defaultValue={allow_edit}
															/>
														</div>
													</div>
												</div>
											</td>
										</tr>
									)
								})}
							</Fieldset>
						</table>

						{!_.isEmpty(revision.notifications_types) &&
							<div className="fieldset">
								<legend>NOTIFICACIÓN</legend>
								<div className="columns">
									<div className="column">
										<div className="field is-grouped is-grouped-multiline">
											<div className="control">
												<label htmlFor="" className="label">Tipo de notificación</label>
												<div className="select">
													<Control.select
														model={type === 'juridica' ? '.agreements.legal.notification_type_id' : '.agreements.admin.notification_type_id'}
														id="status"
														parser={toInt}
														className="select"
														validateOn="change"
													>
														<option value="" defaultValue>--- Tipo ---</option>
														{_.map(revision.notifications_types, (opc, k) => {
															return <option value={opc.id} key={k}>{opc.name}</option>
														})}
													</Control.select>
												</div>
											</div>

											{modality === 'modalidad-i' &&
												revision.agreements.bank_check_show &&
												<div className="control">
													<label className="label">&nbsp;</label>
													<a target="_blank" className="button is-info" href={`${AUTH_URL}/projects/register/agencies/fiscalentity/bank-check-pdf/${modality}/${state}${municipality ? '/' + municipality : ''}`}>
														<span className="icon"><i className="fa fa-link"/></span>
														<span>Generar solicitud de cheque y/o transferencia</span>
													</a>
												</div>
											}
										</div>
									</div>
								</div>
							</div>
						}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-danger" onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							<div className="control">
								<Control.button model="revision" className="button is-success">Guardar
									Comentarios</Control.button>
							</div>
						</div>
					</Form>
				</div>
			</div>
		);
	}

	componentWillMount() {
		let {modality, agreements} = this.props;
		if (!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency)) {
			if (modality === 'modalidad-i' || modality === 'modalidad-iii') {
				this.props.fetchMunicipalities(agreements.data.agency.agenciable_id);
			} else {
				this.props.fetchMunicipalities(agreements.data.agency.agenciable.state_id);
			}
		}
	}

	_handleSubmit(values) {
		let {modality, state, municipality, type} = this.props;
		return this.props.saveAgreements(type === 'administrativo' ? 'admin' : 'legal', modality, state, municipality, values);
	}
}


// WEBPACK FOOTER //
// ./src/elements/revision/agreements.jsx